<script>
  import { Line, mixins } from 'vue-chartjs';

  const { reactiveProp } = mixins;

  export default {
    extends: Line,
    mixins: [reactiveProp],
    data() {
      return {
        chartOptions: {
          scales: {
            yAxes: [{
              ticks: {
                maxTicksLimit: 4,
                min: 0,
                max: 100,
              },
              gridLines: {
                display: true,
              },
            }],
          },
          legend: {
            display: false,
          },
          tooltips: {
            /* eslint-disable */
            custom: tooltipModel => {
              if (tooltipModel.dataPoints) {
                if (tooltipModel.dataPoints[0].datasetIndex === 0) {
                  tooltipModel.borderColor = '#ffcd78';
                } else {
                  tooltipModel.borderColor = '#00c896';
                }
              }
            },
            /* eslint-enable */
            callbacks: {
              /* eslint-disable */
              title: tooltipItem => {
                if (tooltipItem[0].datasetIndex === 0) {
                  return `${Number(tooltipItem[0]['yLabel']).toFixed(1)}%`;
                }
                return `${tooltipItem[0]['yLabel']}${this.$t('common.numeric_score_suffix')}`;
              },
              label: () => (''),
              /* eslint-enable */
            },
            displayColors: false,
            backgroundColor: 'rgba(255,255,255,1)',
            borderColor: '#000000',
            borderWidth: 1,
            titleFontColor: '#000000',
            titleFontStyle: 'normal',
          },
        },
      };
    },
    mounted() {
      this.renderChart(this.chartData, this.chartOptions);
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/classes/components/LineChart.vue